import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationsEN from "./en.json";
import translationsES from "./es.json";

// The translations
const resources = {
  en: {
    translation: translationsEN
  },
  es: {
    translation: translationsES
  }
};

export const changeLanguage = (lng: string) => {
  i18n.changeLanguage(lng);
};

// Detect initial language considering Keycloak
const getInitialLanguage = () => {
  // If there is a language saved in localStorage (from previous sessions), use it
  const storedLang = localStorage.getItem('selectedLanguage');
  if (storedLang) {
    return storedLang.toLowerCase();
  }
  
  // If there is no language saved, use 'en' as default
  // Keycloak will overwrite this in onAuthSuccess if necessary
  return "en";
};

i18n.use(initReactI18next).init({
  resources,
  lng: getInitialLanguage(),
  fallbackLng: "en",
  interpolation: {
    escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
  }
}); 